import React, { Component, ReactElement } from 'react'
import { Route } from '../Annotation/Route'
import { WelcomeContainer } from '../Components/Organisms/WelcomeContainer/WelcomeContainer'
import { StandardContexts } from '../../React/Common/Components/StandardContexts'
import { RouteGuard } from '../Guards/RouteGuard'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { ChangeLanguage } from '../Components/Organisms/ChangeLanguage/Main/ChangeLanguage'

@Route(RouteID.CHANGE_LANGUAGE)
export class ChangeLanguagePage extends Component {
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.CHANGE_LANGUAGE}>
                <StandardContexts>
                    <WelcomeContainer>
                        <ChangeLanguage />
                    </WelcomeContainer>
                </StandardContexts>
            </RouteGuard>
        )
    }
}
